import {StyledMainScreen, StyledControls, StyledLogo, StyledLogoContainer} from './MainScreen.styles';
import Game from './Game';
import {useState} from 'react';
import Story from './Story';
import Future from './Future';
import Video from './Video';

export const MainScreen = () => {
    const [showedContent, setShowedContent] = useState('Duck Game');

    document.addEventListener('keydown', function(event) {
        if(event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "ArrowLeft" || event.key === "ArrowRight") {
            event.preventDefault();
        }
    });

    const onButtonClick = (button) => {
        console.log("button");
        console.log(button)
        if(button === 1) {
            setShowedContent('Duck Game');
            window.location.reload(false);
        } else if(button === 2) {
            setShowedContent('Video');
        } else if(button === 3) {
            setShowedContent('Story');
        } else {
            setShowedContent('Future');
        }
    }

    return (
        <StyledMainScreen>
            {/* <StyledLogoContainer><StyledLogo/></StyledLogoContainer> */}
            <StyledLogoContainer><img src={'duckLOGO.png'} height='100px' width='550px' /></StyledLogoContainer>
            <StyledControls>
                <a className="button1 bouncy" onClick={() => onButtonClick(1)} >Duck Game</a>
                <a className="button1 bouncy" style={{animationDelay:"0.07s"}} onClick={() => onButtonClick(2)}>Video</a>
                <a className="button1 bouncy" style={{animationDelay:"0.14s"}} onClick={() => onButtonClick(3)}>Story</a>
                <a className="button1 bouncy" style={{animationDelay:"0.21s"}} onClick={() => onButtonClick(4)}>Future</a>
            </StyledControls>
            {showedContent === 'Duck Game' ? <Game /> 
            : showedContent === 'Video' ? <Video/>
            : showedContent === 'Story' ? <Story/>
            : <Future/> }
        </StyledMainScreen>
    )
}

export default MainScreen;